import 'select2';

// Main select
$('.js-select-main').select2({
  minimumResultsForSearch: Infinity
});

// Placeholder select for brand
let selectPlaceholder = $('.js-select-placeholder').data('placeholder');

$('.js-select-placeholder').select2({
  'language': {
    'noResults': function () {
      return 'Ничего не найдено';
    }
  },
  placeholder: selectPlaceholder
});